/* loaded by smart-asset */
export default require("./pistachios~DDbsjBIW.png")